export default {"src":"/_next/static/media/Instagram.80a2467e.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};